import { registerPlugin } from '@capacitor/core';

/** @type {import('./definitions.d.ts').SafeAreasPlugin} */
const SafeAreas = registerPlugin('SafeAreas');

export { SafeAreas };
